// Purpose: encode the 52-byte ciphertext header per docs/CRYPTO_FORMAT.md §5.
// Browser-side only needs encode; the server decrypts.

import {
  ALGO_AES_256_GCM,
  CHUNK_SIZE_BYTES,
  FILE_SALT_BYTES,
  FORMAT_VERSION,
  HEADER_BYTES,
  MAGIC,
  OFFSET_ALGO,
  OFFSET_CHUNK_SIZE,
  OFFSET_FILE_SALT,
  OFFSET_MAGIC,
  OFFSET_SIZE_COMMITMENT,
  OFFSET_VERSION,
} from './constants.js';

export async function computeSizeCommitment(plaintextSize: number): Promise<Uint8Array> {
  if (plaintextSize < 0 || !Number.isSafeInteger(plaintextSize)) {
    throw new Error('crypto-web.header: plaintext size must be non-negative safe integer');
  }
  const sizeBytes = new Uint8Array(8);
  new DataView(sizeBytes.buffer).setBigUint64(0, BigInt(plaintextSize), false);
  const digest = await crypto.subtle.digest('SHA-256', sizeBytes);
  return new Uint8Array(digest);
}

export async function encodeHeader(salt: Uint8Array, plaintextSize: number): Promise<Uint8Array> {
  if (salt.length !== FILE_SALT_BYTES) {
    throw new Error(`crypto-web.header: salt must be ${FILE_SALT_BYTES} bytes`);
  }
  const bytes = new Uint8Array(HEADER_BYTES);
  bytes.set(MAGIC, OFFSET_MAGIC);
  bytes[OFFSET_VERSION] = FORMAT_VERSION;
  bytes[OFFSET_ALGO] = ALGO_AES_256_GCM;
  // Reserved bytes left as zero.
  new DataView(bytes.buffer).setUint32(OFFSET_CHUNK_SIZE, CHUNK_SIZE_BYTES, false);
  bytes.set(salt, OFFSET_FILE_SALT);
  const commitment = await computeSizeCommitment(plaintextSize);
  bytes.set(commitment, OFFSET_SIZE_COMMITMENT);
  return bytes;
}
